import React, {useEffect, useState} from "react";
import {formatDate, integerToWord} from "../../utils/helpers";
import Slider from "react-slick";
import {NextArrow, PrevArrow} from "../Dashboard/Account/Accounts";
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

/** @import { Account } from "../Dashboard/DashboardTypes" */
/** @import {MaturityBannerProps} from './DashboardMaturityBannerTypes' */

export function MaturityBanner(/** @type {MaturityBannerProps} */ {maturingAccounts}) {
    const LARGE_BREAKPOINT_WIDTH = 1024;

    const analytics = useUnifiedAnalytics();
    
    const [carouselEnabled, setCarouselEnabled] = useState(window.innerWidth < LARGE_BREAKPOINT_WIDTH)
    
    useEffect(() =>{
        window.addEventListener('resize', onWindowResize, false);
        
    },[])
    const onWindowResize = () => {
        setCarouselEnabled(window.innerWidth < LARGE_BREAKPOINT_WIDTH)
    }
    const goToGiveInstruction = (/** @type {string} */ id, /** @type {string} */ product)  => {
        analytics.trackAnalyticsClickEvent(
            "view your options",
            `/maturity-instruction/${id}`,
            "dashboard maturity banner",
            product,
            "maturity",
            {},
            "link click",
            "navigation|view|maturity",
            "maturity"
        );

        window.location.href = `/maturity-instruction/${id}`;
    }

    const renderRenewalRateOffer = (/** @type {Account} */ maturingAccount) => {
        return <>
            <p>As a thank you for saving with us, we’d like to offer you a renewal rate. The rate you receive will depend on the term you select.</p>
            <p><a className={'maturity3__hyperlink'} onClick={() => goToGiveInstruction(maturingAccount.id, maturingAccount.product.code)}>View your options</a></p>
        </>
    }
    
    const MaturingAccountBox = (/** @type {{maturingAccount: Account}} */ {maturingAccount}) => {
        return <div className={"maturity3__emphasis-box maturity3__emphasis-box--blue maturity3__banner-account"}>
            <h1>{maturingAccount.product.name} ({maturingAccount.accountNumber})</h1>
            <div className={"maturity3__flex-row maturity3__flex-row--responsive no-gap"}>
                <p>{renderRenewalRateOffer(maturingAccount)}</p>
                <p className={'maturity3-maturing-account__info'}>Maturing on {maturingAccount.maturity ? formatDate(new Date(maturingAccount.maturity.maturityDate)) : ''}  </p>
            </div>
        </div>
    }
    
    const renderMaturityAccountsCarousel = () => {
        return carouselEnabled ? 
            <Slider
            className="accounts__carousel account-carousel"
            nextArrow={<NextArrow/>}
            prevArrow={<PrevArrow/>}
            swipe={true}
            swipeToSlide={true}
            draggable={true}
            touchMove={true}
            initialSlide={0}
        >
            {maturingAccounts.map((account)=><MaturingAccountBox maturingAccount={account}/>)}
        </Slider> : 
            <>{maturingAccounts.map((account)=><MaturingAccountBox maturingAccount={account}/>)}</>
    }
    
    const [multipleMaturingAccounts] = useState(maturingAccounts.length > 1);
        
    if (multipleMaturingAccounts){
        return <div className={"text__navy maturity3__dashboard-banner-container maturity3"}>
            <h1>You have {integerToWord(maturingAccounts.length, true)} Fixed Rate Savers maturing soon</h1>
            {renderMaturityAccountsCarousel()}
        </div>
    }
    else {
        return <div className={"text__navy maturity3__dashboard-banner-container maturity3"}>
            <div className={"maturity3__emphasis-box maturity3__emphasis-box--blue maturity3__single-banner-account"}>
                <h1>Your {maturingAccounts[0].product.name} is maturing soon ({maturingAccounts[0].accountNumber})</h1>
                <p>{renderRenewalRateOffer(maturingAccounts[0])}</p>
            </div>
        </div>
    }
}